/**
 * Empty field handling utilities
 *
 * Equivalent to old admin's `c2foBlank` filter
 * Returns "-" for empty/null/undefined values, otherwise returns the value
 */

/**
 * Formats a value to display "-" for empty/null/undefined values
 * Equivalent to old admin's `c2foBlank` filter
 *
 * @param value - The value to format
 * @returns The value if it exists, otherwise "-"
 *
 * @example
 * ```typescript
 * formatEmptyField(null) // Returns "-"
 * formatEmptyField('') // Returns "-"
 * formatEmptyField(undefined) // Returns "-"
 * formatEmptyField('John') // Returns "John"
 * ```
 */
export const formatEmptyField = (value: string | number | null | undefined): string => {
  if (value === null || value === undefined || value === '') {
    return '-';
  }

  return String(value);
};
